import { RootInitialState } from 'core/common/store/rootReducer';

export const getUserResponses = (state: RootInitialState) => state.userResponses;
